// extracted by css-extract-rspack-plugin
export default {"user-icon-wrapper":"VisitationReportsPreview_user-icon-wrapper__muM9+","transparentTable":"VisitationReportsPreview_transparentTable__cVALn"};